import React from 'react';
import { useTranslation } from 'react-i18next';
import { PagePanel, NoLinkIcon, Box } from 'edenred-ui';
import { EmptyState } from '@epi-shared/components';

export function TokenInvalid() {
  const { t } = useTranslation();

  return (
    <PagePanel>
      <Box
        mt={6}
        minHeight={600}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <EmptyState
          icon={<NoLinkIcon />}
          title={t('sign_up.token_invalid_heading')}
          description={t('sign_up.token_invalid_description')}
        />
      </Box>
    </PagePanel>
  );
}
